import type { DashboardCommon } from "@/api/custom_types";
import { LanguageSelector } from "@/components/base";
import { useTranslation } from "@/hooks/useTranslation";
import AddPaymentDialog from "@/pages/payment/shared/AddPaymentDialog";
import { userIntentAtom } from "@/store/login";
import { formatNumber } from "@/utils/tools";
import { Button } from "@st-marketplace/ui";
import { useAtomValue } from "jotai";
import {
	DashboardLayoutHeaderPlatformCurrency,
	DashboardLayoutHeaderStock,
	DashboardLayoutHeaderThemeMenu,
} from "./components";

const DashboardLayoutHeader = ({ data }: { data?: DashboardCommon }) => {
	const { t } = useTranslation();
	const userIntent = useAtomValue(userIntentAtom);

	const isBuyer = userIntent === "BUY";

	return (
		<div className="flex h-20 items-center justify-between border-b border-secondary-border bg-background-0 sticky top-0 z-30">
			{!isBuyer ? (
				<div className="flex items-center overflow-hidden rounded-lg border border-secondary-border bg-background-50 [&>*+*]:border-secondary-border [&>*+*]:border-s">
					<DashboardLayoutHeaderPlatformCurrency
						label={t("header.platformDepts")}
						amount={formatNumber(data?.platform_debts, "price")}
						// Always there: the chip shouldn't reflow when a debt is cleared,
						// and paying ahead of the next commission is allowed.
						action={
							<AddPaymentDialog
								target="platform"
								trigger={(open) => (
									<Button
										type="button"
										color="primary"
										size="sm"
										className="normal-case"
										onClick={open}
									>
										{t("header.payDebt")}
									</Button>
								)}
							/>
						}
					/>
					<DashboardLayoutHeaderPlatformCurrency
						label={t("header.platformFee")}
						caption={t("header.platformFeeCaption")}
						amount={formatNumber(data?.platform_commission, "price")}
					/>
				</div>
			) : (
				<div />
			)}
			<div className="flex items-center gap-5">
				{/* TODO complete notification component  */}
				{!isBuyer && <DashboardLayoutHeaderStock data={data} />}

				<DashboardLayoutHeaderThemeMenu />
				<LanguageSelector compact />
			</div>
		</div>
	);
};

export default DashboardLayoutHeader;
